import { Link } from "react-router-dom";
import CookiePreferencesTrigger from "../../components/CookiePreferencesTrigger";
import { ND1_PRICING } from "../nd1Paths";

const PLATFORM_LINKS = [
  { label: "For job seekers", to: "/job-seekers" },
  { label: "For hiring managers", to: "/hiring-managers" },
  { label: "Product demo: Applying", to: "/how-it-works/applying" },
  { label: "Product demo: Hiring", to: "/how-it-works/hiring" },
  { label: "Pricing", to: ND1_PRICING },
];

const COMPANY_LINKS = [
  { label: "About us", to: "/blog" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "mailto:hello@jobuwin.com", external: true },
];

const LEGAL_LINKS = [
  { label: "Terms of Use", to: "/terms" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Cookie Policy", to: "/cookies" },
];

function FooterLink({ link }) {
  if (link.external) {
    return (
      <a href={link.to} className="nd1-footer__link">
        {link.label}
      </a>
    );
  }
  return (
    <Link to={link.to} className="nd1-footer__link">
      {link.label}
    </Link>
  );
}

export default function Nd1SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="nd1-footer">
      <div className="nd1-shell">
        <div className="nd1-footer__inner">
          <div className="nd1-footer__brand">
            <div className="nd1-footer__logo">Jobuwin</div>
            <p className="nd1-footer__tagline">
              A trusted hiring platform for real people and real opportunities.
            </p>
            <a href="mailto:hello@jobuwin.com" className="nd1-footer__email">
              hello@jobuwin.com
            </a>
            <div className="nd1-footer__social">
              <a
                href="https://www.linkedin.com/company/jobuwin"
                aria-label="JOBUWIN on LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M4.98 3.5A2.5 2.5 0 1 0 5 8.5a2.5 2.5 0 0 0-.02-5ZM3 9h4v12H3V9Zm6 0h3.8v1.7h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.1V21h-4v-5.3c0-1.27-.02-2.9-1.77-2.9-1.78 0-2.05 1.38-2.05 2.8V21H9V9Z" />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@JOBUWIN"
                aria-label="JOBUWIN on YouTube"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M23 12s0-3.2-.4-4.7a2.5 2.5 0 0 0-1.76-1.77C19.27 5.1 12 5.1 12 5.1s-7.27 0-8.84.43A2.5 2.5 0 0 0 1.4 7.3C1 8.8 1 12 1 12s0 3.2.4 4.7a2.5 2.5 0 0 0 1.76 1.77C4.73 18.9 12 18.9 12 18.9s7.27 0 8.84-.43a2.5 2.5 0 0 0 1.76-1.77C23 15.2 23 12 23 12ZM9.75 15.02V8.98L15.5 12l-5.75 3.02Z" />
                </svg>
              </a>
            </div>
          </div>

          <div className="nd1-footer__col">
            <div className="nd1-footer__col-title">Platform</div>
            <ul>
              {PLATFORM_LINKS.map((link) => (
                <li key={link.to}>
                  <FooterLink link={link} />
                </li>
              ))}
            </ul>
          </div>

          <div className="nd1-footer__col">
            <div className="nd1-footer__col-title">Company</div>
            <ul>
              {COMPANY_LINKS.map((link) => (
                <li key={link.label}>
                  <FooterLink link={link} />
                </li>
              ))}
            </ul>
          </div>

          <div className="nd1-footer__col">
            <div className="nd1-footer__col-title">Legal</div>
            <ul>
              {LEGAL_LINKS.map((link) => (
                <li key={link.label}>
                  <FooterLink link={link} />
                </li>
              ))}
              <li>
                <CookiePreferencesTrigger className="nd1-footer__link jw-cookie-preferences-trigger--footer" />
              </li>
            </ul>
          </div>

          <div className="nd1-footer__co-block">
            <div className="nd1-footer__co-title">JOBUWIN Ltd</div>
            <p className="nd1-footer__co">
              JOBUWIN is owned and operated by MotoMob Limited.
              <br />
              Company Number: 12560742
              <br />
              Registered in England and Wales.
            </p>
          </div>
        </div>

        <div className="nd1-footer__bottom">© {year} JOBUWIN.com. All rights reserved.</div>
      </div>
    </footer>
  );
}
